<h2 class="step-title is-size-4-mobile">Please re-enter your phone number.</h2>
<h3>{{subtext}}</h3>
<div class="field">
	<div class="control">
		<input *ngIf = "!inputModeTest"
		class="input is-large"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		type="text" placeholder="(XXX) XXX-XXXX" formControlName="phone_number" [imask]="phoneMask" #phone (change)="snap()">
		<input *ngIf = "inputModeTest"
		inputmode="tel"
		class="input is-large"
		[ngClass]="{'is-danger':highlightingBoxForRequiredInfo && controls[0].touched && controls[0].errors}"
		type="text" placeholder="(XXX) XXX-XXXX" formControlName="phone_number" [imask]="phoneMask" #phone (change)="snap()">
	</div>

	<div *ngIf="controls[0].touched && controls[0].errors" class="help is-danger has-text-left">
		<p *ngIf="controls[0].errors.required">Phone Number is required.</p>
		<p *ngIf="controls[0].errors.pattern">Invalid Phone Number.</p>
	</div>
</div>

<div class="field checkboxes">
	<div class="control has-text-centered">
		<label class="checkbox">
			<input type="checkbox" formControlName="sms" (change)="snap()">
			Prefers text
		</label>
	</div>
	<div class="control has-text-centered">
		<label class="checkbox">
			<input type="checkbox" formControlName="email_preference" (change)="snap()">
			Prefers email
		</label>
	</div>
	<div class="control has-text-centered">
		<label class="checkbox">
			<input type="checkbox" formControlName="prefers_spanish" (change)="snap()">
			Prefers Spanish
		</label>
	</div>
</div>


<button class="button continue is-large has-shadow-small" (click)="submit()">
	View My Rates
<i class="fas fa-chevron-right"></i>
</button>
<p class="tcpa is-size-7 has-text-grey-dark has-text-left">
	<input type="hidden" id="leadid_tcpa_disclosure_form">
	<label for="leadid_tcpa_disclosure_form" class="disclosure-text">
		We take your privacy seriously. By clicking the button above, You agree that we can share your personal data with third parties, such as our mortgage partners, service providers and other affiliates, and that we can use this data for marketing and analytics, and to make your experience easier. you are also providing your<b>express written consent</b> to have your information shared and to be matched with up to five <a href="/approved-lenders" target="_new" rel="nofollow">approved lenders</a> and for them, or their authorized third party, to call you at the number you have provided including through automated means such as autodialing, text SMS/MMS (charges may apply), and prerecorded messaging, and/or via email, even if your telephone number is a cellular phone number or on a corporate, state, or the National Do Not Call Registry, and you agree to our Privacy Policy <a href="/privacy" target="_new" rel="nofollow">Privacy Policy</a>. Consent is not required as a condition to utilize FreeRateUpdate's services, you may choose to use our services by calling 855-315-7283. Consent is not contingent on the purchase and/or use of any services being offered by a Lender.
	</label>
</p>
